import Vue from 'vue'
import App from './views/market/index.vue'
import initAdvSdk from './plugins/init-adv'
import { i18n } from './utils/register/i18n'
import './utils/register/composition-api'
import { isMarket, isMgm, isOfficalWeb } from './utils/scene'
import '@/assets/styles/reset.styl'
import { errorReport } from './utils/errorReport'
import { initWsg } from './utils/wsgenv'
import {setOid2Cookie} from "@/utils/setOid2Cookie";
import { setPageId, trackEvent } from "@/utils/register/omega";
import { PAGE_ID } from '@/constants/page-id'
import { initResourceGuard } from './utils/resourceGuard'

Vue.config.productionTip = false
Vue.use(initAdvSdk)

console.log('是否外投', isMarket())
console.log('是否mgm', isMgm())
console.log('是否官网', isOfficalWeb())

initWsg()
setOid2Cookie()
initResourceGuard()
errorReport()

new Vue({
  i18n,
  render: h => h(App),
    mounted(): void {
        this.$nextTick(() => {
            setPageId(PAGE_ID.MARKET_ENTRY)
            trackEvent('tech_credit_outside_sw', {
                event_name: 'tech_page_show_market'
            })
        });
    },
}).$mount('#app')
